import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import WebResetForm from './Web/ResetForm';
import H5ResetForm from './H5/ResetForm';

const Reset = props => {
    const {agent: {isMobile}} = props;
    return (
        isMobile
            ? <H5ResetForm />
            : <WebResetForm />
    );
};

Reset.propTypes = {
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
};

export default connect(({agent}) => ({agent}))(Reset);
